import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {BasketAnalysisReportData} from "./basket-analysis-report.data";

@Injectable()
export class BasketAnalysisReportModel extends ReportModel<BasketAnalysisReportData> {
    constructor(injector: Injector) {
        super(injector, BasketAnalysisReportData)
    }
}
